// extracted by mini-css-extract-plugin
export default {"shell":"description_shell__T6J3Y","shellMobile":"description_shellMobile__GWics","children":"description_children__3fqTq"};